import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { metaTrack } from './metaPixel';

export const MetaNavigationPageViews = () => {
  const location = useLocation();
  const path = `${location.pathname}${location.search}${location.hash}`;
  const previousPath = useRef(path);

  useEffect(() => {
    if (previousPath.current === path) return;
    previousPath.current = path;
    metaTrack('PageView');
  }, [path]);

  return null;
};